import { CardTypes } from './enums';

export const handleSkippingEndCard = (nextAction, cards, onGoToNextCard) => dispatch => {
    if (nextAction) {
        setTimeout(() => {
            const nextCard = cards[nextAction.order - 1];
            onGoToNextCard(
                nextAction.identifier,
                nextAction.type,
                nextCard.type === CardTypes.multipleActions ||
                    nextCard.type === CardTypes.multiDonation,
                nextCard.type === CardTypes.targetedMultiAction,
                nextAction.skipFrontCard
            );
        }, 100);
    }
};



// WEBPACK FOOTER //
// ./src/utils/handleSkippingEndCard.js